import { render, staticRenderFns } from "./TagWithButton.vue?vue&type=template&id=503ba33d&scoped=true"
import script from "./TagWithButton.vue?vue&type=script&lang=js"
export * from "./TagWithButton.vue?vue&type=script&lang=js"
import style0 from "../../css/tag.css?vue&type=style&index=0&id=503ba33d&prod&scoped=true&lang=css&external"
import style1 from "./TagWithButton.vue?vue&type=style&index=1&id=503ba33d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503ba33d",
  null
  
)

export default component.exports